import gql from 'graphql-tag';

export default gql`
  mutation removeByIdDialogMutation($_id: String!) {
    removeByIdDialogMutation(_id: $_id) {
      _id
    }
  }
`;
